import { useMemo } from 'react';

import {
  useIsAMACreationV2Enabled,
  useIsAMAPrivateEnabled,
  useIsCalendarInvitationEnabled,
  useIsNewQuestionNotificationEnabled,
  useIsQuestionsOnlyMode,
} from '../../featureChecks';
import { UseMainUIFeatureSettings, uiFeatureAccessSymbol } from '../../types';

export const useAskMeAnythingEventEditingPageSettings: UseMainUIFeatureSettings<'askMeAnythingEventEditingPage'> = (
  options
) => {
  const askMeAnythingEventEditingPageOverrides = options?.overrides?.askMeAnythingEventEditingPage;

  const isAMACreationV2Enabled = useIsAMACreationV2Enabled();
  const isAMAPrivateEnabled = useIsAMAPrivateEnabled();
  const isQuestionsOnlyMode = useIsQuestionsOnlyMode();
  const isNewQuestionNotificationEnabled = useIsNewQuestionNotificationEnabled();
  const isCalendarInvitationToggleEnabled = useIsCalendarInvitationEnabled();

  return useMemo(() => {
    if (isQuestionsOnlyMode) {
      return {
        [uiFeatureAccessSymbol]: false,
        private: false,
        newQuestionNotification: isNewQuestionNotificationEnabled,
        calendarInvitationToggleEnabled: isCalendarInvitationToggleEnabled,
        ...askMeAnythingEventEditingPageOverrides,
      };
    }

    return {
      [uiFeatureAccessSymbol]: isAMACreationV2Enabled,
      private: isAMAPrivateEnabled,
      newQuestionNotification: isNewQuestionNotificationEnabled,
      calendarInvitationToggleEnabled: isCalendarInvitationToggleEnabled,
      ...askMeAnythingEventEditingPageOverrides,
    };
  }, [
    askMeAnythingEventEditingPageOverrides,
    isAMACreationV2Enabled,
    isAMAPrivateEnabled,
    isQuestionsOnlyMode,
    isNewQuestionNotificationEnabled,
    isCalendarInvitationToggleEnabled,
  ]);
};
